export default __webpack_public_path__ + "static/media/button talkback-9.c1a75933.png";